import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../locales/en.json';
import fr from '../locales/fr.json';

i18n
  .use(LanguageDetector) // Automatically detects user language
  .use(initReactI18next) // Integrates i18next with React
  .init({
    fallbackLng: 'en', // Fallback language if the desired language is not available
    supportedLngs: ['en', 'fr'], // List of supported languages
    resources: {
      en: { login: en.login },
      fr: { login: fr.login },
    },
    ns: ['login'], // Specify that 'login' is a namespace
    defaultNS: 'login', // Set the default namespace to 'login'
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
